import { Badge, Button, Loader } from '@mantine/core'
import { IconFileMusic, IconFileTypeHtml, IconFileTypePdf, IconFileTypePpt, IconLink, IconNotebook, IconVideo } from '@tabler/icons-react'
import { Link } from 'react-router-dom'

const CONTENT_TYPE_ENUM = {
   'article': "artículo",
   'video': "video",
   'audio': "audio",
   'ebook': "ebook",
   'pdf': "pdf",
   'presentation': "presentación",
   'link': "enlace",
}

const CONTENT_FORMAT_ENUM = {
   'mp4': <IconVideo />,
   'mp3': <IconFileMusic />,
   'pdf': <IconFileTypePdf />,
   'epub': <IconNotebook />,
   'pptx': <IconFileTypePpt />,
   'html': <IconFileTypeHtml />,
   'link': <IconLink />
}

const mapContentType = (value) => {
   if (!value) return ""

   return CONTENT_TYPE_ENUM?.[value?.toLowerCase()] || value
}

const mapContentFormat = (value) => {
   if (!value) return ""

   return CONTENT_FORMAT_ENUM?.[value?.toLowerCase()] || value
}


export default function LibraryContentDetailModal({
   
   isLoading,
   content,
   handleDownload,
   IS_DOWNLOAD_BTN_DISABLED,
   HAS_DOWNLOAD_TRIES,
   IS_TIME_DIFF_AVAILABLE,
   IS_ACTIVE
}) {

   return (
         <div className='Library-content-modal-wrapper'>
            {content.image && <img
               className='Library-content--image Library-content--modal-image' alt={`portada de ${content.title}`}
               src={content.image} />}


            <div className='Library-content-modal-information-wrapper'>
               {content.tags && content.tags?.length > 0 && content?.tags?.map((tag, idx) => (
                  <Badge key={idx}>{tag?.name || tag}</Badge>
               ))}
               {content.lang && <Badge>{content.lang}</Badge>}
            </div>

            <h3 className='Library-content--title'>{content.title}</h3>
            {content.description &&
               <p className='Library-content--description'>{content.description}</p>
            }

            <hr style={{ backgroundColor: '#d3d3d3', width: '100%', height: "1px" }} />

            <div className='Library-content-features-wrapper'>
               {content.author &&
                  <h4 className='Library-content--featureItem'>
                     <strong>Autor & cita: </strong>{content?.author}
                  </h4>
               }
               {content.type &&
                  <h4 className='Library-content--featureItem'>
                     <strong>Tipo: </strong>{mapContentType(content?.type)}
                  </h4>
               }
               {content.format &&
                  <h4 className='Library-content--featureItem'>
                     <strong>Formato: </strong>
                     <span style={{ display: 'flex', alignItems: 'center' }}
                     >
                        {mapContentFormat(content?.format)} {content?.format}
                     </span>
                  </h4>
               }
            </div>

            {((!HAS_DOWNLOAD_TRIES || !IS_TIME_DIFF_AVAILABLE) && !IS_ACTIVE) &&
               <p className='Library-modal--notAvailableText'>
                  {!HAS_DOWNLOAD_TRIES
                     ? "Has agotado tus accesos gratuitas."
                     : "Ya obtuviste un acceso gratuito este mes."
                  }
               </p>
            }

            {IS_DOWNLOAD_BTN_DISABLED && <Button
               color='#e1568b'
               variant='light'
               component={Link}
               target='_blank'
               to='/campus/suscripciones'
            >
               Accedé al plan sin límites
            </Button>}

            <Button
               disabled={IS_DOWNLOAD_BTN_DISABLED || isLoading}
               onClick={() => handleDownload(content?._id)}
               color='#e1568b'
            >
               {isLoading ? <Loader /> : "Acceder al contenido"}
            </Button>

         </div>
   )
}
